module.exports = __webpack_public_path__ + "static/media/status-missed.094305d4.svg";